<docs>
# domain-select Component

```pug
domain-select(
    @change="domainChange",
    tip="该功能仅用于基础流量代码自动检查"
    extra="为网站$domain绑定推广平台账户"
)
```
</docs>

<template lang="pug">
.domain-select
    | {{label}}
    v-select(
        v-model="domainId",
        :options="domainListOptions")
        
        .select-wrapper
            template(v-for="(option, key) in domainListOptions")
                v-option(
                    :key="option.label",
                    :disabled="option.disabled",
                    :label="option.label",
                    :value="option.value")

                    .option-wrapper
                      span(:title="option.label") {{option.label}}

    span(style="color: #d2b025;", v-if="tip")
        i.fa.fa-info-circle(style="margin-right: 5px;")
        | {{ tip }}
    span(style="color: #999;", v-show="showExtraHTML", v-html="'（' + extraHTML + '）'")
</template>

<script>
    /**
     * 选取 Object[] 中符合条件的第一个元素
     * 如果没有符合条件的  则默认返回第一个元素
     */
    const getMatchOrFirst = (list = [], key, val) => {
        let match = list.getParticularObjectInArray(key, val);
        return match || list[0];
    };
    const arrToSelectOptions = (arr) => arr.map((item) => {
        return {
            value: item.id,
            label: item.domain
        };
    });

    export default {
        props: {
            label: {
              type: String,
              default: '当前网站：'
            },
            tip: {
                type: String,
                required: false
            },
            extra: {
                type: String,
                required: false
            }
        },

        data() {
            return {
                domainId : this.$store.state.domainId,
                isHovered : false,
                currentLabel : ''
            };
        },

        computed: {
            domainListOptions() { 
                return arrToSelectOptions(this.$store.state.domainList);
            },
            extraHTML() {
                let domain = this.currentDomain.domain;
                if (!domain) {
                    return '';
                }
                domain = domain.length > 30 ? (domain.slice(0, 30) + '...') : domain;
                return (this.extra || '').replace(/\$domain/g, `<cite>${domain}</cite>`);
            },
            showExtraHTML() {
                return this.extra && this.currentDomain.domain;
            },
            currentDomain() {
                return this.$store.state.currentDomain || {};
            },
            domainList() {
                return this.$store.state.domainList || [];
            }
        },
        methods: {
            commitChange() {
                let domain = _.find(this.domainList, { id: this.domainId });
                this.$store.commit('SET_DOMAINID', { domainId: this.domainId });
                this.$store.commit('SET_CURRENT_DOMAIN', { domain });
                this.$emit('change', domain);
            }
        },
        watch: {
            domainId() {
                this.commitChange();
            }
        },
        mounted() {
            if (this.currentDomain) {
                this.$emit('change', this.currentDomain);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// domain-select.vue?63da1ea4